import { load_one, load_many } from '../action-helpers.js'

export default {

    loadAll: load_many('countries'),
    loadOne: load_one('countries/:id'),

}
